import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space[3]} ${space[4]} ${space[5]};
  display: flex;
  flex-direction: column;
  gap: ${space[5]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[5]} ${space[7]};
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  flex-wrap: wrap;
`;

export const TitleText = styled.h2`
  margin: 0;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size.xl};
  line-height: 1.2;
  color: ${colors.fontPrimary};
  flex: 1;
  min-width: 0;
`;

export const ConfirmationRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[2]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
`;

export const ConfirmationCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[4]};
  height: ${space[4]};
  border-radius: ${layout.borderRadiusFull};
  background: ${colors.success};
  color: ${colors.white};
`;

export const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[5]};
`;

export const TotalRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const RecommendationsHeading = styled.p`
  margin: 0;
  text-align: center;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size['2xl']};
  line-height: 1.2;
  color: ${colors.fontPrimary};
`;

export const RecommendationsHeadingSecondary = styled.span`
  color: ${colors.fontSecondary};
`;

export const ActionBar = styled.div`
  display: flex;
  gap: ${space[3]};
  padding: ${space[4]};
  background: ${colors.white};
  border-top: 1px solid ${colors.borderGreyLighter};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[5]} ${space[7]};
  }
`;

export const TotalLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-family: ${fonts.body};
`;

export const TotalLabel = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
`;
